import * as mobx from 'mobx';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { isBefore } from 'date-fns';
import { IGenerateRoomsDTO } from '../../../../../../../api/rooms.dao';
import { setToCurrentDay } from '../../../../../../../infrastructure/utils/date-fns-overrides.utils';
import { ConnectionVersion } from '../../../../../../../constants/common.constants';
import { hasPermission } from '../../../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../../../api/roles.dao';

class GenerateRoomsFormDataVM {
    @mobx.observable
    private formChecked: boolean;
    @mobx.observable
    public endTimeDate: Date;
    @mobx.observable
    public startTimeDate: Date;
    @mobx.observable
    public connectionVersion: ConnectionVersion;

    private eventTimezone: string;

    constructor(
        eventStart: Date,
        eventEnd: Date,
        eventTimezone: string
    ) {
        this.formChecked = false;
        // convert time to zoned for user show and set current day
        this.startTimeDate = setToCurrentDay(utcToZonedTime(eventStart, eventTimezone));
        this.endTimeDate = setToCurrentDay(utcToZonedTime(eventEnd, eventTimezone));
        this.eventTimezone = eventTimezone;
        this.connectionVersion = hasPermission(Permission.CREATE_NEW_ROOM_V2) ? ConnectionVersion.V2 : ConnectionVersion.V1;
    }

    public getStartTimeError() {
        return !this.startTimeDate ? 'Start time is required field!' : this.getTimeError();
    }

    public getEndTimeError() {
        return !this.endTimeDate ? 'End time is required field!' : this.getTimeError();
    }

    public getTimeError() {
        return !isBefore(this.startTimeDate, this.endTimeDate) ? 'Start time cannot be equal or greater than End time' : null;
    }

    @mobx.action
    public checkForm(): boolean {
        this.formChecked = true;
        return !this.getStartTimeError() && !this.getEndTimeError();
    }

    public isFormChecked() {
        return this.formChecked;
    }

    public toApiDTO(): IGenerateRoomsDTO {
        // send to API date in UTC
        return {
            endTime: zonedTimeToUtc(this.endTimeDate, this.eventTimezone),
            startTime: zonedTimeToUtc(this.startTimeDate, this.eventTimezone),
            connectionVersion: this.connectionVersion,
        };
    }

    @mobx.action
    public setConnectionVersionField = (value: ConnectionVersion) => {
        this.connectionVersion = value;
    };
}

export { GenerateRoomsFormDataVM };
